import { useEffect, useState } from "react";
import { LoadingOverlay } from "../components/Loading/Loading";
import useFontLoader from "./useFontLoader";
import assetsConfig from "../assetsConfig";
import { useSettings } from "../hooks/UseSettings";
import { useSelector } from "react-redux";
import { RootState } from "../store";

// wait for assets or other config settings to load before rendering app
const AssetsLoader = (props: { children: React.ReactNode }) => {
	const { children } = props;
	const { settings: localSettings } = useSettings();
	const { labels } = useSelector((state: RootState) => state.labels);
	const { fontsLoaded } = useFontLoader([
		assetsConfig.colors.fontBrandSrc,
		assetsConfig.colors.fontHeadingSrc,
		assetsConfig.colors.fontCopySrc,
	]);
	const [allLoaded, setAllLoaded] = useState(false);

	useEffect(() => {
		if (
			assetsConfig &&
			Object.values(assetsConfig).length !== 0 &&
			Object.values(assetsConfig.colors).length !== 0 &&
			Object.values(localSettings).length !== 0 &&
			Object.values(labels).length !== 0 &&
			fontsLoaded
		) {
			setAllLoaded(true);
		}
	}, [assetsConfig, localSettings, labels, fontsLoaded]);

	// Render the application content only when all assets and settings are loaded
	if (allLoaded) {
		return <>{children}</>;
	} else {
		return (
			<LoadingOverlay
				show={true}
				message="Loading Assets & Application Settings"
			/>
		);
	}
};

export default AssetsLoader;
